export default __webpack_public_path__ + "static/abm-badge-8f82d92801cb624fc56fca3aab49a84e.png";